var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "right-arrow-7288805"
  }, /*#__PURE__*/React.createElement("path", {
    id: "right arrow",
    d: "M21.69 11.7098C21.6521 11.6206 21.5978 11.5392 21.53 11.4698L18.53 8.46985C18.3878 8.33737 18.1998 8.26524 18.0055 8.26867C17.8112 8.2721 17.6258 8.35081 17.4884 8.48823C17.351 8.62564 17.2723 8.81102 17.2688 9.00532C17.2654 9.19963 17.3375 9.38767 17.47 9.52985L19.19 11.2498H3C2.80109 11.2498 2.61032 11.3289 2.46967 11.4695C2.32902 11.6102 2.25 11.8009 2.25 11.9998C2.25 12.1988 2.32902 12.3895 2.46967 12.5302C2.61032 12.6708 2.80109 12.7498 3 12.7498H19.19L17.47 14.4698C17.3295 14.6105 17.2507 14.8011 17.2507 14.9998C17.2507 15.1986 17.3295 15.3892 17.47 15.5298C17.6106 15.6703 17.8012 15.7492 18 15.7492C18.1988 15.7492 18.3894 15.6703 18.53 15.5298L21.53 12.5298C21.5978 12.4605 21.6521 12.3791 21.69 12.2898C21.7296 12.1983 21.7501 12.0996 21.7501 11.9998C21.7501 11.9001 21.7296 11.8014 21.69 11.7098Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/RightArrow.dad324d1ffac7cc1590bedef8f0decb6.svg";
export { ForwardRef as ReactComponent };